import * as React from 'react';
import classnames from 'clsx';
import MenuButtonLink from '../../MenuButtonLink';
import MenuButtonBackground from '../../MenuButtonBackground';
import type { MenuButtonProps } from '../../../MenuButton.types';
import MenuButtonRoot from '../../MenuButtonRoot';

type BaseButtonProps = MenuButtonProps & {
  skinsStyle: any;
  skin:
    | 'LinesMenuButtonNBorderRadiusFixSkin'
    | 'LinesMenuButtonNSkin'
    | 'RibbonsMenuButtonNSkin'
    | 'SloppyBorderMenuButtonNSkin'
    | 'SolidColorMenuButtonNSkin'
    | 'TextOnlyMenuButtonNSkin'
    | 'TextSeparatorsMenuButtonNSkin';
};

const BaseButton: React.FC<BaseButtonProps> = props => {
  const {
    id,
    'aria-haspopup': ariaHasPopup,
    'aria-describedby': ariaDescribedBy,
    'aria-current': ariaCurrent,
    'aria-expanded': ariaExpanded,
    isMoreButton,
    dir,
    textAlign,
    positionInList,
    link,
    skinsStyle,
    skin,
    role,
  } = props;

  return (
    <MenuButtonRoot
      {...props}
      className={classnames(props.className, skinsStyle[skin])}
    >
      {label => (
        <MenuButtonLink
          wrapperProps={{
            positionInList,
            ariaHasPopup,
            ariaDescribedBy,
            isMoreButton,
            ariaExpanded,
            ariaCurrent,
            role,
          }}
          link={link}
          className={skinsStyle.linkElement}
        >
          <div className={skinsStyle.wrapper}>
            <MenuButtonBackground
              wrapperProps={{ dir, textAlign, id }}
              classNames={{ bg: skinsStyle.bg, label: skinsStyle.label }}
            >
              {label}
            </MenuButtonBackground>
          </div>
        </MenuButtonLink>
      )}
    </MenuButtonRoot>
  );
};

export default BaseButton;
